<template>
    <div class="flex space-x-1">
        <input
            type="checkbox"
            :id="id"
            :value="modelValue"
            :checked="isChecked"
            @change="emitUncheck($event.target.checked)"
            @input="$emit('update:modelValue', $event.target.value)"
        />
        <span>{{ label }}</span>
    </div>
</template>

<script>
export default {
    name: "Checkbox",
    props: {
        modelValue: { type: String, default: "" },
        isChecked: Boolean,
        label: { type: String },
        value: { type: Array },
        id: { type: Number },
    },
    methods: {
        emitUncheck(event) {
            if(!event){
                this.$emit('remove-selected-filter', this.id);
            }
        }
    }
};
</script>
